import { DropdownMenu, MenuItem } from '@reckon-web/dropdown';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  LogOutIcon,
  RefreshCwIcon,
} from '@reckon-web/icon';
import { ActionButton } from '@reckon-web/button';
import { Flex } from '@reckon-web/flex';
import { useTheme } from '@reckon-web/theme';
import { makeId } from '@reckon-web/utils';
import { Inline } from '@reckon-web/inline';
import { Text } from '@reckon-web/text';

import { signout, silentRefresh } from '../auth';
import { useGetMyDetails } from '../../data/useGetMyDetails';
import { NamedUserAvatar } from '../common/named-user-avatar';

const APPLICATION_VERSION = process.env.APPLICATION_VERSION;

export const Profile = ({ testId = 'profile' }) => {
  const { data, loading, error } = useGetMyDetails();
  const theme = useTheme();

  // TODO
  if (loading) return <div>Loading...</div>;
  if (error || !data) return <div>Error!</div>;

  const { user } = data;

  if (!user) return <div>Error!</div>;

  return (
    <DropdownMenu
      trigger={({ triggerProps, isOpen }) => (
        <ActionButton
          {...triggerProps}
          weight="subtle"
          css={{
            height: theme.sizing.base, // FIXME: remove or document
          }}
          data-testid={makeId(testId, 'action-button')}
        >
          <Flex alignItems="center" gap="small">
            <NamedUserAvatar
              avatarSize="small"
              textSize="small"
              user={user}
              hideName
              testId={makeId(testId, 'avatar')}
            />
            {isOpen ? (
              <ChevronUpIcon size="small" />
            ) : (
              <ChevronDownIcon size="small" />
            )}
          </Flex>
        </ActionButton>
      )}
      data-testid={makeId(testId, 'dropdown-menu')}
    >
      {(process.env.NODE_ENV === 'development' ||
        localStorage.getItem('debugMode') === 'true') && (
        <MenuItem
          id="header-button-refresh-token"
          icon={RefreshCwIcon}
          onClick={() => silentRefresh()}
          tone="active"
          label="Refresh token"
        />
      )}
      <MenuItem
        icon={LogOutIcon}
        label="Logout"
        onClick={signout}
        tone="critical"
        data-testid={makeId(testId, 'menu-item')}
      />
      <Inline paddingX="large" paddingTop="small" alignY="center">
        <Text color="muted" size="xsmall">
          Version: {APPLICATION_VERSION}
        </Text>
      </Inline>
    </DropdownMenu>
  );
};
